import { AfterContentInit, Component, Inject, Input, OnDestroy, ViewChild } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";
import { findIndex } from "lodash";
import { Subscription } from "rxjs";
import { ICommonFilterActionCreator } from "../../redux/actions.interface";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { toggleFilterReducerFactory } from "./reducer";
import { TOGGLE_FILTER_STATE_PROP } from "./state-props";

import { NS_UIState } from "../../types";

@Component({
    selector: "common-toggle-filter",
    templateUrl: "./common-toggle-filter.component.html",
})
export class CommonToggleFilterComponent implements AfterContentInit, OnDestroy {
    @Input() public listActions: ICommonFilterActionCreator<any>;
    @Input() public initialState: NS_UIState.ICommonToggleFilterState;
    @Input() public fieldToFilter: string;
    @Input() public fieldType: "pill" | "buttonGroup" = "pill";
    @Input() @BooleanAttribute() public keepStateAliveOnDestroy = false;

    @ViewChild("actions", { static: true }) public actions;

    public filters: any[];
    private state$: Subscription;

    constructor(private ngRedux: ImmutableRedux<any>,
                @Inject(TOGGLE_FILTER_STATE_PROP) public rootProp ) {
    }

    public ngAfterContentInit() {
        if (!this.keepStateAliveOnDestroy) {
            this.ngRedux.registerComponent(toggleFilterReducerFactory, this.rootProp, this.stateProp, this.initialState);
        } else if (!this.ngRedux.checkState(this.rootProp, this.stateProp)) {
            this.ngRedux.registerComponent(toggleFilterReducerFactory, this.rootProp, this.stateProp, this.initialState);
        }
        this.state$ = this.ngRedux.select(this.rootProp, this.stateProp).subscribe((state) => {
            this.filters = state.filters;
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    public get stateProp() {
        return `${this.listActions.rootProp}::${this.listActions.stateProp}::${this.fieldToFilter}`;
    }

    public reset() {
        if (!this.keepStateAliveOnDestroy) {
            this.actions.reset();
        }
    }

    public get isPill(): boolean {
        return this.fieldType === "pill";
    }

    public get isButtonGroup(): boolean {
        return this.fieldType === "buttonGroup";
    }

    public getActiveIndex(): number {
        return findIndex(this.filters, (f) => f.state);
    }

    public handleFilter(index, fieldToFilter) {
        if (index === this.getActiveIndex()) { return; }
        this.actions.toggleButtonGroup(index);
        this.listActions.filter(fieldToFilter, this.filters[index].value);
    }
}
